import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import TechDetail from "./pages/TechDetail";
import ArticleDetail from "./pages/ArticleDetail";
import About from "./pages/About";
import DevopsTools from "./pages/DevopsTools";
import PricingPage from "./pages/PricingPage";
import PricingSuccess from "./pages/PricingSuccess";
import PricingCancel from "./pages/PricingCancel";
import Assessment from "./pages/Assessment";
import ThankYou from "./pages/ThankYou";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/tech/:slug" element={<TechDetail />} />
          <Route path="/insights/:slug" element={<ArticleDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/devops-tools" element={<DevopsTools />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/pricing/success" element={<PricingSuccess />} />
          <Route path="/pricing/cancel" element={<PricingCancel />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
